import { Tooltip } from "@mui/material";
import { SelectField } from "src/components/FormikComponents/SelectField";
import { FormikSelectField } from "src/components/MUI5FormikComponents/FormikWrappers";

interface IDefinitionStartProps {
  initialValue: number;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

interface IDaysOfMonthOption {
  label: string;
  value: number;
  className?: string;
}

const daysOfMonthOptions = (): IDaysOfMonthOption[] => {
  const daysOfMonth: IDaysOfMonthOption[] = [];
  for (let i = 1; i < 32; i++) {
    daysOfMonth.push({ label: `${i}`, value: i });
  }
  return daysOfMonth;
};

export const DefinitionStart = (props: IDefinitionStartProps): JSX.Element => {
  const { initialValue, value, onChange, disabled } = props;
  const isDirty = initialValue !== value;

  return (
    <Tooltip title="Match results only include pairings starting after calendar date" placement="top">
      <div>
        <SelectField
          className={`start_control ${isDirty ? "dirty" : ""}`}
          name="definition_startday"
          label="Start"
          isMulti={false}
          value={daysOfMonthOptions().find((o) => o.value === value)}
          onChange={(dom: IDaysOfMonthOption) => {
            onChange(dom?.value ?? null);
          }}
          options={daysOfMonthOptions()}
          placeholder=""
          meta={{
            initialValue: initialValue,
            touched: isDirty,
          }}
          isSearchable={false}
          isClearable={true} //not working atm
          maxMenuHeight={200}
          disabled={disabled}
        />
      </div>
    </Tooltip>
  );
};
